import {createFeatureSelector, createSelector} from '@ngrx/store';
import {EState} from 'src/app/state/reducers';
import {ICategoryListState} from '../models/category-list-state.model';

export const selectCategoryListState = createFeatureSelector<ICategoryListState>(EState.CategoryList);
export const selectCategoryListStatus = createSelector(
  selectCategoryListState,
  (categoryListState: ICategoryListState) => categoryListState.status
);
export const selectCategoryList = createSelector(
  selectCategoryListState,
  (categoryListState: ICategoryListState) => categoryListState.successResponse
);
export const selectCategoryListError = createSelector(
  selectCategoryListState,
  (categoryListState: ICategoryListState) => categoryListState.errorMessage
);
